import React from "react";
import { useUrlFilterState } from "../../../infecto-lms-admin/components/core/filters/useUrlFilterState";

export interface UserWhoMadeNodeFilter {
    filterByLastName?: string;
    filterByFirstName?: string;
}

interface Search {
    filters: UserWhoMadeNodeFilter;
    setFilters: (filters: UserWhoMadeNodeFilter) => void;
    clearFilters: () => void;
}

export const UserWhoMadeContentNodeSearchContext = React.createContext<Search>({
    setFilters: () => {},
    clearFilters: () => {},
    filters: {},
});

interface OwnProps {
    children: any;
}

export const UserWhoMadeContentNodeSearchContainer = ({ children }: OwnProps) => {
    const { state, setState } = useUrlFilterState<UserWhoMadeNodeFilter>();

    return (
        <UserWhoMadeContentNodeSearchContext.Provider
            value={{
                filters: state,
                setFilters: (filters) => {
                    setState(() => filters);
                },
                clearFilters: () => {
                    setState({});
                },
            }}
        >
            {children}
        </UserWhoMadeContentNodeSearchContext.Provider>
    );
};
